"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uploadFileSwaggerMetadata = uploadFileSwaggerMetadata;
exports.replaceFileSwaggerMetadata = replaceFileSwaggerMetadata;
exports.deleteFileSwaggerMetadata = deleteFileSwaggerMetadata;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const swagger_1 = require("@nestjs/swagger");
class FileUploadDto {
}
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        type: "string",
        format: "binary",
        description: "The file to be uploaded.",
    }),
    tslib_1.__metadata("design:type", Object)
], FileUploadDto.prototype, "file", void 0);
function uploadFileSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Upload a file",
        description: "Uploads a file to the server and processes it.",
    }), (0, swagger_1.ApiConsumes)("multipart/form-data"), (0, swagger_1.ApiQuery)({
        name: "companyType",
        required: true,
        description: "The type of the company for which the file is being uploaded.",
        example: "insurance",
    }), (0, swagger_1.ApiQuery)({
        name: "companyId",
        required: true,
        description: "The ID of the company for which the file is being uploaded.",
        example: 123,
    }), (0, swagger_1.ApiQuery)({
        name: "documentTypeLid",
        required: true,
        description: "The type of document being uploaded.",
        example: "policy",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiBody)({
        description: "Payload for uploading a file.",
        type: FileUploadDto,
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "File uploaded successfully.",
        schema: {
            type: "object",
            properties: {
                status: { type: "number", example: 200 },
                message: { type: "string", example: "File uploaded successfully" },
                data: {
                    type: "object",
                    properties: {
                        id: { type: "number", example: 11 },
                        fileName: { type: "string", example: "example_file.pdf" },
                        fileUrl: {
                            type: "string",
                            example: "uploads/insurance/uploads/example_file.pdf",
                        },
                        fileBuffer: {
                            type: "string",
                            example: "Base64 encoded string of the file content",
                        },
                    },
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 400,
        description: "File is required or invalid file type.",
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal server error.",
    }));
}
function replaceFileSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Replace a file",
        description: "Replaces an existing file with a new file by its ID.",
    }), (0, swagger_1.ApiConsumes)("multipart/form-data"), (0, swagger_1.ApiQuery)({
        name: "id",
        required: true,
        description: "The ID of the file to replace.",
        example: 1,
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiBody)({
        description: "Payload for replacing a file.",
        type: FileUploadDto,
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "File replaced successfully.",
        schema: {
            type: "object",
            properties: {
                status: { type: "number", example: 200 },
                message: { type: "string", example: "File replaced successfully" },
                data: {
                    type: "object",
                    properties: {
                        id: { type: "number", example: 1 },
                        companyType: { type: "string", example: "insurance" },
                        companyId: { type: "number", example: 123 },
                        fileUrl: {
                            type: "string",
                            example: "uploads/insurance/uploads/updated_file.pdf",
                        },
                        fileName: { type: "string", example: "updated_file.pdf" },
                        fileBuffer: {
                            type: "string",
                            example: "Base64 encoded string of the file content",
                        },
                    },
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 400,
        description: "File ID or file is required.",
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: "File not found.",
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal server error.",
    }));
}
function deleteFileSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Delete a file",
        description: "Deletes a file by its ID and moves it to the deleted folder.",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiQuery)({
        name: "id",
        required: true,
        description: "The ID of the file to delete.",
        example: 1,
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "File deleted successfully.",
        schema: {
            type: "object",
            properties: {
                status: { type: "number", example: 200 },
                message: { type: "string", example: "File deleted successfully" },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 400,
        description: "File ID is required.",
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: "File not found.",
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal server error.",
    }));
}
